import React from 'react';

interface FormProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function FormProgress({ currentStep, totalSteps }: FormProgressProps) {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-3">
        <span className="text-supporting text-text-secondary">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-supporting text-trust-blue font-medium">
          {Math.round(progressPercentage)}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 relative overflow-hidden">
        <div
          className={`bg-trust-blue h-2 rounded-full transition-all duration-300 absolute top-0 left-0 origin-left`}
          data-progress={progressPercentage}
          style={{
            width: `${progressPercentage}%`
          }}
        />
      </div>
    </div>
  );
}